import React, { Component } from 'react';
import { Navbar, Button } from 'react-bootstrap';
import './Login.css';
import App from './App';

class Login extends Component {
  constructor(props){
    super(props);
    console.log(props)
  }
  goTo(route) {
    this.props.history.replace(`/${route}`)
  }

  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.auth.logout();
  }

  render() {
    const { loggedIn, login, logout } = this.props.auth;
    
    if(!loggedIn ){     
       login()   
        
    }
    if(loggedIn){
      return (
        
        <App logout={logout}/>
      )  
    }
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js